// actions/permissionsActions.js
export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const UPDATE_PERMISSION = "UPDATE_PERMISSION";
export const CLEAR_PERMISSIONS = "CLEAR_PERMISSIONS";

// Set all permissions (e.g., after fetching menus)
export const setPermissions = (data) => ({
  type: SET_PERMISSIONS,
  payload: data,
});

// Update a single permission (read/edit toggle)
export const updatePermission = (id, type, value) => ({
  type: UPDATE_PERMISSION,
  payload: { id, type, value },
});

// Clear permissions (reset state)
export const clearPermissions = () => ({
  type: CLEAR_PERMISSIONS,
});
